import { lazyLoad } from 'app/utils/loadable';

export const Payments = lazyLoad(
  () => import('./payments'),
  (module) => module.Payments
);
